export const environment = {
    baseUrl: '',
    production: true,
    apiURL: 'https://api-order.posapp.vn/v1',
    setDefaultLang: 'vi',
    clientId: 'mnRZ6u9DWm',
    clientSecret: 'HdhClxkTjFyV295PfGH9AgHKv86MOyeZ',
    firebase: {
        projectId: 'user-system-7b84a',
        appId: '1:473441446377:web:9e2f9e5adffa1a070fc378',
        databaseURL: 'https://user-system-7b84a-default-rtdb.firebaseio.com',
        storageBucket: 'user-system-7b84a.appspot.com',
        apiKey: 'AIzaSyC3IqQLWeLp0A6ATLg6ff4aiXJsVT0nBqk',
        authDomain: 'user-system-7b84a.firebaseapp.com',
        messagingSenderId: '473441446377'
    },
    version: '2.4.1',
    sentryEnvironment: 'fnb-production',
    appType: 'fnb',
    ga: 'G-LRE5S9F16M',
    pusher: {
        appKey: '54183637319749290244',
        wsHost: 'ws.posapp.vn',
        wsPort: 80,
        wssPort: 443,
        cluster: ''
    }
};
